export default __webpack_public_path__ + "a2067d5389efb2f1258095eda4004480.png";